export default "<!-- TODO: add a title and inputs -->\n<app-club-location></app-club-location>\n";